import templateUrl from "emun.invoice/credit-request/credit-request-details-header.htm";

export default () => ({ templateUrl });
